import React from 'react';
import { TrendingUp, Package, CheckCircle, AlertCircle } from 'lucide-react';

interface KPICardsProps {
  totalOrders: number;
  completedOrders: number;
  pendingOrders: number;
  completionRate: number;
  productionMatchRate: number;
}

export const KPICards: React.FC<KPICardsProps> = ({
  totalOrders,
  completedOrders,
  pendingOrders,
  completionRate,
  productionMatchRate,
}) => {
  const kpis = [
    {
      title: 'Total Ventas',
      value: totalOrders,
      icon: Package,
      color: 'bg-blue-500',
      bgColor: 'bg-blue-50',
      textColor: 'text-blue-700',
    },
    {
      title: 'Completadas',
      value: completedOrders,
      icon: CheckCircle,
      color: 'bg-green-500',
      bgColor: 'bg-green-50',
      textColor: 'text-green-700',
    },
    {
      title: 'Pendientes',
      value: pendingOrders,
      icon: AlertCircle,
      color: 'bg-yellow-500',
      bgColor: 'bg-yellow-50',
      textColor: 'text-yellow-700',
    },
    {
      title: 'Tasa Cumplimiento',
      value: `${completionRate.toFixed(1)}%`,
      icon: TrendingUp,
      color: 'bg-green-500',
      bgColor: 'bg-green-50',
      textColor: 'text-green-700',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {kpis.map((kpi, index) => (
        <div
          key={index}
          className="bg-white rounded-xl shadow-sm border border-slate-200 p-6"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-slate-600 mb-1">{kpi.title}</p>
              <p className={`text-3xl font-bold ${kpi.textColor}`}>
                {kpi.value}
              </p>
            </div>
            <div className={`w-12 h-12 ${kpi.bgColor} rounded-lg flex items-center justify-center`}>
              <kpi.icon className={kpi.textColor} size={24} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
